import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["required", "aria-required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ueberschrift, { titel: _ctx.ueberschriftText }, null, 8, ["titel"]),
    _createVNode(_component_zeile, { "spacing-y": false }, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": true,
          "info-box-id": "tariffDiscountHuGInfo"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.titel), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_zelle, { class: "mkRadio" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.hugMitglied) = $event)),
              type: "radio",
              id: "tariffDiscountHuGYes",
              name: "tariffDiscountHuG",
              value: true,
              "data-cy": "tariffDiscountHuGYes",
              "aria-label": "Ja, ich bin Haus und Grund Mitglied"
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.hugMitglied]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "tariffDiscountHuGYes",
              class: "radiolabel"
            }, "Ja", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.hugMitglied) = $event)),
              type: "radio",
              id: "tariffDiscountHuGNo",
              name: "tariffDiscountHuG",
              value: false,
              "data-cy": "tariffDiscountHuGNo",
              "aria-label": "Nein, ich bin kein Haus und Grund Mitglied",
              "aria-describedby": "tariffDiscountHuGInfo"
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.hugMitglied]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "tariffDiscountHuGNo",
              class: "radiolabel"
            }, "Nein", -1)),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.tariffDiscountHuG,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_info_box, {
              role: "tooltip",
              id: "tariffDiscountHuGInfo"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Der Eigentümerverband Haus & Grund vertritt die Interessen privater Haus-, Wohnungs- und Grundeigentümer. Dem Zentralverband Haus & Grund Deutschland mit Sitz in Berlin sind die über 20 Landesverbände und ca. 900 Ortsvereine mit rund 900.000 Mitgliedern angeschlossen. Als Haus & Grund-Mitglied erhalten Sie in allen Sparten 10% Rabatt.\" ")
              ])),
              _: 1,
              __: [3]
            })
          ]),
          _: 1,
          __: [4,5]
        })
      ]),
      _: 1
    }),
    (_ctx.piniaStore.state.tarifinformationen.hugMitglied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Ort des Vereins")
                ])),
                _: 1,
                __: [6]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_dropdown, {
                    name: "huGOrt",
                    "wert-aktuell": _ctx.piniaStore.state.personendaten.versicherungsnehmer.hugMitgliedOrt,
                    dropdowndaten: _ctx.dropdowndatenHuGOrt,
                    onUpdateVorschlag: _ctx.updateHugMitgliedOrt
                  }, null, 8, ["wert-aktuell", "dropdowndaten", "onUpdateVorschlag"]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler?.huGOrt
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Mitgliedsnummer")
                ])),
                _: 1,
                __: [7]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "hugMembershipNumber",
                    name: "hugMembershipNumber",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.hugMitgliedNummer) = $event)),
                    class: "c-form-control__input",
                    placeholder: "Mitgliedsnummer",
                    minlength: "2",
                    maxlength: "10",
                    required: _ctx.piniaStore.state.tarifinformationen.hugMitglied,
                    "aria-required": _ctx.piniaStore.state.tarifinformationen.hugMitglied,
                    "data-fehlermeldung": "Bitte geben Sie Ihre Mitgliedsnummer ein (max. 10 Zeichen).",
                    "data-cy": "hugMitgliedNummer"
                  }, null, 8, _hoisted_2), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.personendaten.versicherungsnehmer.hugMitgliedNummer,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler?.hugMembershipNumber
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}